// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__1svBS","content":"Consent_content__2TIjE","footer":"Consent_footer__eg0dn"};